<div class="row col-12 p-0 m-0 main-page-section">
  <div class="p-0">
    <!-- <app-side-nav [item]="meetingNav"></app-side-nav> -->
  </div>
  <div class="col-11 p-0 credit-section">
    <!-- <app-header></app-header> -->
    <div class="container-fluid div-height" *ngIf="tenantDetail">
      <div class="row breadcrumbs-section">
        <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
        <span class="separator">&nbsp;>&nbsp; </span>
        <span class="curr-page pl-2 ">&nbsp;&nbsp; Credit Points</span>
      </div>

      <div class="row row-1">
        <div class="col-sm-9 ml-3">
          <h5>Credit Points</h5>
        </div>
        <div class="col-sm-2 ml-5">
          <p class="request pt-2 pl-3 pointer-link" (click)="CreditUsageReport()">Credit Usage</p>
          <!-- <p class="request pt-2 pl-3 pointer-link"routerLink="/reports">Credit Usage</p> -->
          <!-- <a class="request pt-2 pl-3 " [routerLink]="['/reports']" ></a> -->
        </div>
      </div>

      <div class="row row-2">
        <div class="col-sm-4">
          <p class="credit-header">Total Credit Points</p>
          <p class="output credit-header font-bold">{{getTotalCredit(tenantDetail)}}</p>
          <p class="outputDerived credit-header">{{getPoints(tenantDetail, 1)}} Complimentary +
            {{getPoints(tenantDetail, 2)}}
            Purchased</p>
          <p class="request credit-header font-bold pointer-link" (click)="RequestCreditpoints()">Request Credit Points
          </p>
        </div>
        <div class="col-sm-4 reserved-section">
          <p class="credit-header">Reserved</p>
          <!-- <p class="output credit-header font-bold">
            {{getTenantCredit(tenantDetail, 'reserved', 'used')}}/{{getTenantCredit(tenantDetail, 'reserved','total')}}
            balance
          </p> -->
          <p class="output credit-header font-bold">
            {{getTenantCredit(tenantDetail, 'reserved','total')}}
            balance
          </p>
          <!-- <p class="outputDerived credit-header">{{ getUsedResrvedCreditPoints(tenantDetail)}} points used</p> -->
          <button type="button" class="request" placement="bottom" [autoClose]="'outside'" triggers="manual"
            #p="ngbPopover" (click)="p.open()" [ngbPopover]="popContent">
            Disburse More
          </button>

          <ng-template #popContent>
            <div class="row popoverTitle">Disburse Credit Points</div>
            <div class="row list">
              <p class="col-lm-9 popoverText">Available Credit Points balance <span class="ml-3 pl-5">
                  {{getTenantCredit(tenantDetail, 'reserved', 'used')}}</span></p>
            </div>
            <div class="row list">
              <p class="col-sm-8 pl-0 popoverText margin-auto ml-0">Credits to be disbursed</p>
              <input class="col-sm-3 mb-2 ml-0 pl-1" id="Dcredit" type="number" min="0"  (change)="onKeypressEvent($event)" (keyup)="onKeypressEvent($event)"
                oninput="validity.valid||(value=value.replace(/\D+/g, ''))" [(ngModel)]=disbursePoints>
            </div>
            <hr>

            <button type="submit" [disabled]= "!maxValue" class="disburseButton" (click)="open(content)" (click)="p.close()">Disburse</button>
            <!-- <button type="submit" class="disburseButton" (click)="open(content)" (click)="p.close()" [disabled]="(getAvailableForDisburse(getTenantCredit(tenantDetail, 'reserved','total'),getTenantCredit(tenantDetail, 'reserved', 'used')))<=0">Disburse</button>
            <p *ngIf="(getAvailableForDisburse(getTenantCredit(tenantDetail, 'reserved','total'),getTenantCredit(tenantDetail, 'reserved', 'used')))<=0">No points to disburse</p> -->
            <ng-template #content let-modal>
              <div class="modal-body p-1 pb-3 pt-3" >
                <p class="modalText m-3">Are you sure, you want to disburse {{disbursePoints}} credit points?</p>
              </div>
              <div class="modal-footer p-3">
                <button type="button" class="cancelButton" (click)="modal.close('Save click')">Cancel</button>
                <button type="button" class="disburseButton"
                  (click)="disburse();modal.close('Save click')">Disburse</button>
              </div>
            </ng-template>

          </ng-template>

        </div>
        <div class="col-sm-4">
          <p class="credit-header">Common Pool</p>
          <p class="output credit-header font-bold">
            {{getTenantCredit(tenantDetail, 'pool', 'used')}}/{{getTenantCredit(tenantDetail, 'pool','total')}} balance
          </p>
          <p class="outputDerived credit-header">{{ getUsedPoolCreditPoints(tenantDetail)}} points used</p>
        </div>
      </div>




      <ng-container *ngIf="tenantUser && tenantUser.length>0 && tenantUser !== undefined; else noTenantUserList">
        <div class="row row-3 " *ngFor="let list of tenantUsers | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:tenantUsers.length }">
          <div class="col-sm-1">
            <img src="{{list.profileUri}}" alt="User" *ngIf="list.profileUri; else user">
            <ng-template #user>
              <p class="icon">{{generateInitials(list.userName)}}</p>
            </ng-template>
          </div>
          <div class="col-sm-9">
            <p class="name">{{list.userName}}</p>
            <div><img class="group" src="../../../assets/images/credit-small.png">
              <p class="creditPoint pl-3">Credit Points Used : {{list.creditsUsed}}</p>
            </div>
          </div>
          <div class="col-sm-2 ">
            <p class="pt-2 points">Credit Points</p>
            <label class="switch">
              <input type="checkbox" [checked]="list.isCreditPointAccess"
                (change)="updateCreditPointAccess(list.userId, !list.isCreditPointAccess)">
              <span class="slider round "></span>
            </label>
          </div>
        </div>
      </ng-container>
      <ng-template #noTenantUserList>
        <div class="row row-3 ">
          No Users Found
        </div>
      </ng-template>


    </div>
    <div class="d-flex justify-content-center pagination-section" *ngIf="tenantUsers?.length>=10">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="refreshPagination($event)" nextLabel=""
          class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="tenantUser?.length>=10">10/{{tenantUsers?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{tenantUser?.length}}/{{tenantUsers?.length}}</div>
      </div>
    </div>
  </div>
